import { Link, Text } from "@certn/cascadia-react";
import { getPrivacyPolicyUrl } from "@certn/utils";
import { css } from "@emotion/css";
import { JsonSchema4, JsonSchema7 } from "@jsonforms/core";
import { Trans, useTranslation } from "react-i18next";

import { IncomeVerificationSkipModal } from "./IncomeVerificationSkipModal";

type Props = {
  skipOptions: JsonSchema4[] | JsonSchema7[] | undefined;
  otherSkipReason: string | undefined;
};

export function IncomeVerificationTextBoxesAndSkip(props: Props) {
  const { skipOptions, otherSkipReason } = props;
  const { i18n } = useTranslation();
  const language = i18n.language.split("-")[0];
  const privacyPolicyUrl = getPrivacyPolicyUrl(language);

  return (
    <>
      <Text
        style="form/body-secondary"
        color="text-weak"
        className={styles.paddingBottom}
      >
        <Trans>
          Please see our{" "}
          <Link
            linkStyle="monochrome"
            testID="privacy-policy-link"
            href={privacyPolicyUrl}
            target="_blank"
          >
            privacy policy
          </Link>{" "}
          for more information about Certn's privacy practices and your privacy
          rights.{" "}
          <IncomeVerificationSkipModal
            skipOptions={skipOptions}
            otherSkipReason={otherSkipReason}
          />{" "}
          <Text color="text-base" style="global/heading-small">
            if you wish to skip this step
          </Text>
          , you will be required to give your reasoning.
        </Trans>
      </Text>
    </>
  );
}

const styles = {
  paddingBottom: css({
    paddingBottom: "var(--space-2)",
  }),
};
